import { Component, DOCUMENT, inject } from '@angular/core';
import { IFRAME_HEIGHT_ADJUSTMENT } from '@shared/constants/ui-format.constants';
import { SharedModule } from '@shared/shared.module';
import { IframeContainerService } from './iframe-container.service';

@Component({
	selector: 'pms-iframe-container',
	templateUrl: './iframe-container.component.html',
	imports: [
		SharedModule,
	],
})
export class IframeContainerComponent {
	document = inject<Document>(DOCUMENT);
	iframeContainerService = inject(IframeContainerService);

	get iframeHeight() {
		return this.document.defaultView.innerHeight - IFRAME_HEIGHT_ADJUSTMENT;
	}
}
